import React, { useState, useRef, useEffect } from 'react';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
import { getToken, getUserId } from "../../api/index";
import { updateUser } from "../../api/auth";
import Loader from '../Loader';
import { Snackbar, Alert } from '@mui/material';
import './EditGender.css';

const EditGender = () => {
    const allGenders = [
        "Male",
        "Female",
        "Non-Binary",
    ];
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.userDetails.userDetails);
    const [genderMenuOpen, setGenderMenuOpen] = useState(false);
    const [gender, setGender] = useState(userDetails?.gender ? userDetails.gender : "");
    const [isLoading, setIsLoading] = useState(false);
    const genderDropdownRef = useRef(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar({ ...snackbar, open: false });
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleGenderOnChange = (g) => {
        setGender(g);
        setGenderMenuOpen(false);
    };

    const handleGenderDrowpdownClick = () => {
        setGenderMenuOpen(!genderMenuOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutsideGender = !genderDropdownRef.current || !genderDropdownRef.current.contains(event.target);
            if (isOutsideGender) {
                setGenderMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSubmit = async () => {
        if (isLoading) return;
        if (!gender) {
            showSnackbar('Please select a gender', 'error');
            return;
        }
        setIsLoading(true);
        const token = getToken();
        const payload = {
            userId: getUserId(),
            gender: gender,
        };

        try {
            const response = await updateUser(payload, token);
            console.log("response", response);

            if (response && response.success !== false) {
                showSnackbar('Gender updated successfully!', 'success');
                dispatch(setUserDetails({ ...userDetails, gender: gender }));
            } else {
                showSnackbar('Failed to update gender. Please try again.', 'error');
            }
        } catch (error) {
            console.log("error", error);
            showSnackbar('An error occurred while updating. Please try again.', 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="EditGender">
            <div className="editGenderContainer">
                <div className="editGenderCard">
                    <span className="editGenderLabel">Gender</span>
                    <div className="genderDropdownContainer" ref={genderDropdownRef}>
                        <div
                            id="gender"
                            className="genderSelect"
                            onClick={handleGenderDrowpdownClick}
                        >
                            {!gender ? (
                                <span className="genderPlaceholder">Select Gender</span>
                            ) : (
                                <span className="genderInputText">{gender}</span>
                            )}
                            <span className="genderArrowIcon">
                                {genderMenuOpen ? (
                                    <KeyboardArrowUpRoundedIcon />
                                ) : (
                                    <KeyboardArrowDownRoundedIcon />
                                )}
                            </span>
                        </div>

                        {genderMenuOpen && (
                            <ul className="genderDropdownMenu">
                                {allGenders.map((g, index) => (
                                    <li
                                        key={index}
                                        onClick={() => handleGenderOnChange(g)}
                                    >
                                        {g}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="editGenderSubmitBtnContainer">
                    <button
                        className="editGenderSubmitBtn"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <Loader /> : "Update"}
                    </button>
                </div>
            </div>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default EditGender;